<template>
  <div class="page">
    <div class="page__container">
      <slot name="header" />
      <div class="page__main">
        <div class="page__sidebar">
          <slot name="sidebar" />
        </div>
        <div class="page__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
a {
  color: unset;
  text-decoration: unset;
  &:hover {
    color: #024089;
    text-decoration: unset;
  }
}
$sidebar-width: 211px;
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  &__container {
    min-width: 1170px;
    max-width: 1170px;
    h2 {
      margin: 80px 0px;
      text-align: left;
    }
    @media (max-width: 1200px) {
      min-width: unset;
      width: 100%;
      h2 {
        padding-left: 20px;
        margin: 40px 0px 60px;
      }
    }
  }
  &__main {
    display: flex;
    @media (max-width: 475px) {
      flex-direction: column;
    }
  }
  &__sidebar {
    background: #024089;
    width: $sidebar-width;
    color: white;
    padding: 68px 15px 20px;
    @media (max-width: 475px) {
      width: 100%;
      min-height: 200px;
    }
  }
  &__content {
    width: calc(100% - $sidebar-width);
    background: #f8f8f8;
    color: #000000;
    padding: 48px;
    @media screen and (min-width: 1200px) {
      min-height: 540px;
    }
    @media (max-width: 475px) {
      width: 100%;
      padding: 40px 20px 20px;
    }
  }
}
</style>
<style lang="scss">
.menu__item.router-link-exact-active.router-link-active {
  .item__title,
  .item__icon {
    color: #f1bc04;
  }
}

.admin {
  .sidebar {
    &__menu {
      display: flex;
      flex-direction: column;
    }
  }

  .menu {
    &__item {
      display: flex;
      cursor: pointer;
      align-items: center;
      + .menu__item {
        margin-top: 10px;
      }
    }
  }

  .item {
    &__icon {
      width: 26px;
      margin-right: 15px;
      svg {
        width: 100%;
      }
    }
    &__title {
      color: #ffffff;
      font-size: 20px;
      line-height: 24px;
      &:hover {
        color: #f1bc04;
      }
    }
  }
  .content {
    &__title {
      font-weight: 500;
      font-size: 22px;
      line-height: 25px;
      margin-bottom: 12px;
    }
    &__group {
      padding: 20px;
      width: 100%;
      background: white;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
    }
  }
}
.img-fit {
  width: 100%;
  object-fit: contain;
}
</style>
